export const NO_LONGER_AVAILABLE_ERROR_CODE = 'no-longer-available';

export type TokenErrorCode =
  | 'invalid'
  | 'expired'
  | 'already-responded'
  | 'already-used'
  | typeof NO_LONGER_AVAILABLE_ERROR_CODE
  | 'unknown';

export class TokenError extends Error {
  code: TokenErrorCode;
  constructor(code: TokenErrorCode) {
    super(code);
    this.code = code;
  }
}

export function mapTokenErrorCode(
  status: number,
  body: { code?: string }
): TokenErrorCode {
  if (status === 404) return 'invalid';
  if (status === 410) return 'expired';
  if (status === 409 && body.code === 'already-used') return 'already-used';
  if (status === 409 && body.code === NO_LONGER_AVAILABLE_ERROR_CODE) {
    return NO_LONGER_AVAILABLE_ERROR_CODE;
  }
  if (status === 409) return 'already-responded';
  return 'unknown';
}

export async function getByToken<T>(url: string): Promise<T> {
  const res = await fetch(url, { credentials: 'include' });
  if (res.ok) return res.json() as Promise<T>;
  const body = await res.json().catch(() => ({}));
  throw new TokenError(mapTokenErrorCode(res.status, body));
}

export async function postByToken(
  url: string,
  payload: unknown
): Promise<void> {
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (res.ok) return;
  const body = await res.json().catch(() => ({}));
  throw new TokenError(mapTokenErrorCode(res.status, body));
}

export function tokenErrorCodeOf(err: unknown): TokenErrorCode {
  return err instanceof TokenError ? err.code : 'unknown';
}
